<template>
    <div class="main text-left" v-on:scroll.passive="onScroll">
        <div　class="ja pb-3"><!--en pb-3 mx-1-->
            <p class="head">{{ $t('menu.terms') }}</p>
            <!-- article - 1 -->
            <p class="chapter">{{ $t('outline.forcing.article1.title') }}</p>
            <p class="no-bullet">{{ $t('outline.forcing.article1.text') }}</p>

            <!-- article - 2 -->
            <p class="chapter">{{ $t('outline.forcing.article2.title') }}</p>
            <p class="no-bullet">{{ $t('outline.forcing.article2.text') }}</p>
            <p>{{ $t('outline.forcing.article2.point1') }}</p>
            <p>{{ $t('outline.forcing.article2.point2') }}</p>
            <p>{{ $t('outline.forcing.article2.point3') }}</p>
            <p>{{ $t('outline.forcing.article2.point4') }}</p>
            <p>{{ $t('outline.forcing.article2.point5') }}</p>
           
            <!-- article - 3 -->
            <p class="chapter">{{ $t('outline.forcing.article3.title') }}</p>
            <p class="no-bullet">{{ $t('outline.forcing.article3.text') }}</p>
            <p>{{ $t('outline.forcing.article3.point1') }}</p>
            <p>{{ $t('outline.forcing.article3.point2') }}</p>
            <p>{{ $t('outline.forcing.article3.point3') }}</p>

            <!-- article - 4 -->
            <p class="chapter">	{{ $t('outline.forcing.article4.title') }}</p>
            <p>{{ $t('outline.forcing.article4.point1') }}</p>
            <p>{{ $t('outline.forcing.article4.point2') }}</p>

            <!-- article - 5 -->
            <p class="chapter">{{ $t('outline.forcing.article5.title') }}</p>
            <p class="no-bullet">{{ $t('outline.forcing.article5.text') }}</p>

            <!-- article - 6 -->
            <p class="chapter">	{{ $t('outline.forcing.article6.title') }}</p>
            <p class="no-bullet">{{ $t('outline.forcing.article6.text') }}</p>

            <!-- article - 7 -->
            <p class="chapter">	{{ $t('outline.forcing.article7.title') }}</p>
            <p>{{ $t('outline.forcing.article7.point1') }}</p>
            <p>{{ $t('outline.forcing.article7.point2') }}</p>
            <p>{{ $t('outline.forcing.article7.point3') }}</p>

            <!-- article - 8 -->
            <p class="chapter">	{{ $t('outline.forcing.article8.title') }}</p>
            <p>{{ $t('outline.forcing.article8.point1') }}</p>
            <p>{{ $t('outline.forcing.article8.point2') }}</p>
            <p>{{ $t('outline.forcing.article8.point3') }}</p>
            <p>{{ $t('outline.forcing.article8.point4') }}</p>
            <p>{{ $t('outline.forcing.article8.point5') }}</p>
            <p>{{ $t('outline.forcing.article8.point6') }}</p>
            <p>{{ $t('outline.forcing.article8.point7') }}</p>

            <!-- article - 9 -->
            <p class="chapter">	{{ $t('outline.forcing.article9.title') }}</p>
            <p>{{ $t('outline.forcing.article9.point1') }}</p>
            <p>{{ $t('outline.forcing.article9.point1_1') }}</p>
            <p>{{ $t('outline.forcing.article9.point1_2') }}</p>
            <p>{{ $t('outline.forcing.article9.point1_3') }}</p>
            <p>{{ $t('outline.forcing.article9.point1_4') }}</p>
            <p>{{ $t('outline.forcing.article9.point2') }}</p>
            <p>{{ $t('outline.forcing.article9.point3') }}</p>

            <!-- article - 10 -->
            <p class="chapter">	{{ $t('outline.forcing.article10.title') }}</p>
            <p>{{ $t('outline.forcing.article10.point1') }}</p>
            <p>{{ $t('outline.forcing.article10.point2') }}</p>

            <!-- article - 11 -->
            <p class="chapter">	{{ $t('outline.forcing.article11.title') }}</p>
            <p class="no-bullet">{{ $t('outline.forcing.article11.text') }}</p>

            <!-- article - 12 -->
            <p class="chapter">	{{ $t('outline.forcing.article12.title') }}</p>
            <p>{{ $t('outline.forcing.article12.point1') }}</p>
            <p>{{ $t('outline.forcing.article12.point1_1') }}</p>
            <p>{{ $t('outline.forcing.article12.point1_2') }}</p>
            <p>{{ $t('outline.forcing.article12.point1_3') }}</p>
            <p>{{ $t('outline.forcing.article12.point1_4') }}</p>
            <p>{{ $t('outline.forcing.article12.point2') }}</p>
            <p>{{ $t('outline.forcing.article12.point3') }}</p>
            <p>{{ $t('outline.forcing.article12.point4') }}</p>

            <!-- article - 13 -->
            <p class="chapter">	{{ $t('outline.forcing.article13.title') }}</p>
            <p class="no-bullet">{{ $t('outline.forcing.article13.text') }}</p>

            <!-- article - 14 -->
            <p class="chapter">	{{ $t('outline.forcing.article14.title') }}</p>
            <p class="no-bullet">{{ $t('outline.forcing.article14.text') }}</p>

            <!-- article - 15 -->
            <p class="chapter">	{{ $t('outline.forcing.article15.title') }}</p>
            <p>{{ $t('outline.forcing.article15.point1') }}</p>
            <p>{{ $t('outline.forcing.article15.point2') }}</p>
            <p>{{ $t('outline.forcing.article15.point3') }}</p>

            <!-- article - 16 -->
            <p class="chapter">	{{ $t('outline.forcing.article16.title') }}</p>
            <p>{{ $t('outline.forcing.article16.point1') }}</p>
            <p>{{ $t('outline.forcing.article16.point1_1') }}</p>
            <p>{{ $t('outline.forcing.article16.point1_2') }}</p>
            <p>{{ $t('outline.forcing.article16.point1_3') }}</p>
            <p>{{ $t('outline.forcing.article16.point2') }}</p>
            <p>{{ $t('outline.forcing.article16.point2_1') }}</p>
            <p>{{ $t('outline.forcing.article16.point2_2') }}</p>
            <p>{{ $t('outline.forcing.article16.point2_3') }}</p>
            <p>{{ $t('outline.forcing.article16.point2_4') }}</p>
            <p>{{ $t('outline.forcing.article16.point2_5') }}</p>
            <p>{{ $t('outline.forcing.article16.point3') }}</p>
            <p>{{ $t('outline.forcing.article16.point4') }}</p>

            <!-- article - 17 -->
            <p class="chapter">	{{ $t('outline.forcing.article17.title') }}</p>
            <p>{{ $t('outline.forcing.article17.point1') }}</p>
            <p>{{ $t('outline.forcing.article17.point2') }}</p>
            <p>{{ $t('outline.forcing.article17.point3') }}</p>
            <p>{{ $t('outline.forcing.article17.point4') }}</p>
            <p>{{ $t('outline.forcing.article17.point5') }}</p>

            <!-- article - 18 -->
            <p class="chapter">	{{ $t('outline.forcing.article18.title') }}</p>
            <p>{{ $t('outline.forcing.article18.text') }}</p>

            <!-- article - 19 -->
            <p class="chapter">	{{ $t('outline.forcing.article19.title') }}</p>
            <p>{{ $t('outline.forcing.article19.text') }}</p>

            <!-- article - 20 -->
            <p class="chapter">	{{ $t('outline.forcing.article20.title') }}</p>
            <p>{{ $t('outline.forcing.article20.text') }}</p>

            <!-- article - 21 -->
            <p class="chapter">	{{ $t('outline.forcing.article21.title') }}</p>
            <p>{{ $t('outline.forcing.article21.point1') }}</p>
            <p>{{ $t('outline.forcing.article21.point2') }}</p>
            <p>{{ $t('outline.forcing.article21.point3') }}</p>
            <p>{{ $t('outline.forcing.article21.point4') }}</p>
            <p>{{ $t('outline.forcing.article21.point5') }}</p>
            <p>{{ $t('outline.forcing.article21.point6') }}</p>

            <!-- article - 22 -->
            <p class="chapter">	{{ $t('outline.forcing.article22.title') }}</p>
            <p>{{ $t('outline.forcing.article22.point1') }}</p>
            <p>{{ $t('outline.forcing.article22.point2') }}</p>
            <p>{{ $t('outline.forcing.article22.point3') }}</p>
            <p>{{ $t('outline.forcing.article22.point4') }}</p>

            <!-- article - 23 -->
            <p class="chapter">	{{ $t('outline.forcing.article23.title') }}</p>
            <p>{{ $t('outline.forcing.article23.point1') }}</p>
            <p>{{ $t('outline.forcing.article23.point2') }}</p>
            <p>{{ $t('outline.forcing.article23.point3') }}</p>
            <p>{{ $t('outline.forcing.article23.point4') }}</p>
            <p>{{ $t('outline.forcing.article23.point5') }}</p>
            
            <!-- article - 24 -->
            <p class="chapter">{{ $t('outline.forcing.article24.title') }}</p>
            <p class="no-bullet">{{ $t('outline.forcing.article24.text') }}</p>

            <!-- article - 25 -->
            <p class="chapter">{{ $t('outline.forcing.article25.title') }}</p>
            <p>{{ $t('outline.forcing.article25.point1') }}</p>
            <p>{{ $t('outline.forcing.article25.point2') }}</p>
            <p>{{ $t('outline.forcing.article25.point3') }}</p>
            
            <!-- article - 26 -->
            <p class="chapter">	{{ $t('outline.forcing.article26.title') }}</p>
            <p>{{ $t('outline.forcing.article26.point1') }}</p>
            <p>{{ $t('outline.forcing.article26.point2') }}</p>

            <!-- article - 27 -->
            <p class="chapter">	{{ $t('outline.forcing.article27.title') }}</p>
            <p class="no-bullet">{{ $t('outline.forcing.article27.text') }}</p>
            
            <!-- article - 28 -->
            <p class="chapter">	{{ $t('outline.forcing.article28.title') }}</p>
            <p class="no-bullet">{{ $t('outline.forcing.article28.text') }}</p>
            
            <!-- enactment date, revision date -->
            <p class="chapter">
                {{ $t('outline.enactment_date', {
                    y: 2019,
                    m: 12,
                    M: 'December',
                    d: 17,
                }) }}
            </p>
            <p class="chapterDay">
                {{ $t('outline.last_revision_date', {
                    y: 2023,
                    m: 5,
                    M: 'May',
                    d: 31,
            }) }}
            </p>
        </div>
    </div>
</template>
<script>
    import moment from "moment";
    export default {
        name: 'MembershipFeePolicyDetail',
        
        created() {

        },
        mounted() {
        },
        methods: {
            onScroll(event) {
                if (event.target.scrollHeight - 50 <= event.target.scrollTop + event.target.clientHeight) {
                    this.$emit('displayed');
                }
            }
        },
        computed: {
        },
    }
</script>
<style scoped>
    @import "~vodal/common.css";
    @import "~vodal/slide-down.css";

    .ja p {
        padding-left: 5em;
        text-indent: -1em;
    }
    .ja p.no-bullet {
        padding-left: 4em;
        text-indent: 0;
    }
    .ja p.chapter {
        padding-left: 2em;
        text-indent: 0;
        margin-top: 1em;
    }
    .ja p.chapterDay {
        padding-left: 2em;
        text-indent: 0;
        margin-top: 0em;
    }
    p.head {
        padding-left: 0;
        text-indent: 0;
    }
    .en p {
        margin-bottom: 0.5em;
    }
    .en p.article {
        padding-left: 0;
        text-indent: 0;
        margin-top: 2em;
    }
    .en p.number {
        padding-left: 2em;
        text-indent: -2em;
    }
    .en p.indent {
        padding-left: 2em;
    }
    .en p.head-out-indent {
        padding-left: 2em;
        text-indent: -2em;
    }
</style>